import { IDelegateWorkRequest } from '../views/Campaign/campaignInterfaces'
// import msalApi from 'msalApi'
import msalApi from "../config/setupMSALAxios"; // your configured msalApi instance

// the following 2 apis are for work items that HAVE NOT been delegated
export function getMyDashboards() {
  return msalApi.get('/api/Campaign/GetMyDashboards').then((result) => result.data)
}

export function fetchDashboardTaskDetails(containerId: number) {
  return msalApi.get('/api/Campaign/GetMyDashboardTaskDetails', { params: { containerId } }).then((result) => result.data)
}

// the following 2 apis are for work items that HAVE been delegated
// fetch the delegated summary
export function fetchDelegatedDashboard() {
  return msalApi.get('/api/Campaign/GetDelegatedDashboard').then((result) => result.data)
}

// fetch the patients for a particular campaign/filter
export function fetchDelegatedFilterPatients(containerId: number) {
  return msalApi.get('/api/Campaign/GetDelegatedFilterPatients', { params: { containerId } }).then((result) => result.data)
}

export function getMyWorkItems() {
  return msalApi.get('/api/Campaign/GetMyWorkItems').then((result) => result.data)
}

export function getDelegationWorkItems() {
  return msalApi.get('/api/Campaign/GetMyDashboardWorkItems').then((result) => result.data)
}

export function delegateWorkItems(reassignWorkRequest) {
  return msalApi.post('/api/Campaign/PostDelegateSelected', reassignWorkRequest).then((result) => result.data)
}

export function getDelegatedItems() {
  return msalApi.get('/api/Campaign/GetDelegatedWork').then((result) => result.data)
}

export function completeWorkItems(completedWorkItems) {
  return msalApi.post('/api/Campaign/PostCompletedWorkItems', completedWorkItems).then((result) => result.data)
}

export function delegateWork(records: IDelegateWorkRequest) {
  return msalApi.post('/api/Campaign/DelegateWork', records).then((result) => result.data)
}
